import React, { useState } from 'react'
import { type ClickNavigationSection } from '../../../../../components/NavigationWithSideBar/ClickNavigation'
import { Button } from '../../../../../components/Button/Button'
import { LinkNewEmailModal } from '../../../Connectors/ModalIntegrationConnectors/DelegatedEmail/LinkNewEmailModal'
import { DelegatedEmailList } from './DelegatedEmailList'
import { useGetMeQuery } from '../../../../../store/user/user'
import { useAppSelector } from '../../../../../store/hooks'
import { selectAccountId } from '../../../../../store/auth/authSlice'
import { IntegrationServiceId } from '../../../../../common/integrations'
import { Stack } from 'react-bootstrap'

const MAX_DELEGATED_EMAIL_COUNT = 2

const DelegatedEmailSettings: React.FC = () => {
  const [showLinkEmailModal, setShowLinkEmailModal] = useState(false)
  const accountId = useAppSelector(selectAccountId)
  const { data: currentUser, isFetching } = useGetMeQuery({ accountId })

  const delegatedEmailIntegrations = currentUser?.integrations?.filter((integration) => integration.serviceId === IntegrationServiceId.DELEGATED_EMAIL) ?? []

  return (
    <Stack gap={3} className='col-12 col-lg-8'>
      <p>Link up to {MAX_DELEGATED_EMAIL_COUNT} extra email addresses so Zocks picks up meeting invitations from all your calendars.</p>
      <DelegatedEmailList isFetching={isFetching} integrations={delegatedEmailIntegrations} />
      {delegatedEmailIntegrations.length < MAX_DELEGATED_EMAIL_COUNT && (
        <Button variant='primaryGhost' onClick={() => setShowLinkEmailModal(true)} className='zocks-border-dashed'>
          <i className='bi bi-plus-circle' /> Link email
        </Button>
      )}
      {showLinkEmailModal ? <LinkNewEmailModal onHide={() => setShowLinkEmailModal(false)} /> : null}
    </Stack>
  )
}

export const DelegatedEmailSpecificSettings = (): ClickNavigationSection[] => {
  return [{ id: 'linkedEmails', label: 'Linked emails', content: () => <DelegatedEmailSettings /> }]
}
